import React from 'react';
import { Typography, Alert, Empty } from 'antd';
import { MessageOutlined } from '@ant-design/icons';
import { useAuth } from '../../contexts/AuthContext';

const { Title, Paragraph } = Typography;

const MessagePage = () => {
 const { isAdmin, isManager } = useAuth();

 // RBAC Check (can also be done via routing)
 if (!isAdmin && !isManager) {
     return <Alert message="Access Denied" description="You do not have permission to view messages." type="warning" showIcon />;
 }

return (
    <div>
    <Title level={2}><MessageOutlined style={{ marginRight: 8 }} /> Messages</Title>
    <Paragraph>
        This section will display incoming messages related to quotes or projects.
        Functionality like reading, replying, and filtering messages will be implemented here.
    </Paragraph>
    {/* Placeholder for message list */}
    <Empty description="Message functionality coming soon." />
    </div>
);
};

export default MessagePage;